import { ArrowRight, ArrowDown } from "lucide-react";

export const BendHero = () => {
  return (
    <section
      id="hero"
      data-testid="bend-hero-section"
      className="relative min-h-screen flex flex-col justify-center bg-white overflow-hidden pt-20"
    >
      <div className="absolute top-0 right-0 w-[50vw] h-full bg-[#F8FAFC] hidden lg:block" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 w-full pt-12 pb-20 md:pt-8 md:pb-0">
        {/* Headline */}
        <h1
          data-testid="bend-hero-headline"
          className="font-['Playfair_Display'] font-semibold text-[#0F172A] tracking-[-0.03em] leading-[0.95] anim-fade-up delay-1 text-[clamp(44px,6.5vw,100px)]"
        >
          <span className="md:hidden">Marketing<br />Built to Scale<br /><span className="text-highlight">Bend Businesses.</span></span>
          <span className="hidden md:inline">Marketing built to scale <span className="text-highlight">Bend businesses.</span></span>
        </h1>

        {/* Subheadline */}
        <div className="mt-10 md:mt-14 max-w-[540px] anim-fade-up delay-3">
          <p
            data-testid="bend-hero-subheadline"
            className="text-[17px] md:text-[19px] lg:text-[20px] leading-[1.65] text-[#475569]"
          >
            We're two senior marketers based in Bend. We run the ads and build
            the pages that get more local people through your door. Whether
            you're just getting started or already spending, we pick up from
            wherever you are. It's the two of us, no junior team you'll never meet.
          </p>
        </div>

        {/* CTAs */}
        <div className="mt-10 md:mt-14 flex flex-col sm:flex-row gap-4 anim-fade-up delay-5">
          <a
            href=""
            onClick={(e) => { e.preventDefault(); window.Calendly?.initPopupWidget({url: 'https://calendly.com/bldventuresgroup-marketing/30min'}); }}
            data-testid="bend-hero-cta-button"
            className="calendly-cta btn-primary inline-flex items-center justify-center gap-3 bg-[#0064E0] text-white rounded-xl px-10 py-[18px] text-[16px] font-medium hover:bg-[#0052CC] focus:outline-none focus:ring-2 focus:ring-[#0064E0] focus:ring-offset-2 sm:w-auto w-full"
          >
            Book a Discovery Call
            <ArrowRight className="arrow-icon w-[18px] h-[18px]" />
          </a>
          <a
            href="#process"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#process")?.scrollIntoView({ behavior: "smooth" });
            }}
            data-testid="bend-hero-secondary-cta"
            className="btn-outline inline-flex items-center justify-center gap-2 bg-transparent text-[#0F172A] border-2 border-[#E2E8F0] rounded-xl px-10 py-[18px] text-[16px] font-medium focus:outline-none focus:ring-2 focus:ring-[#0F172A] focus:ring-offset-2 sm:w-auto w-full"
          >
            See how we work
            <ArrowDown className="w-[18px] h-[18px]" />
          </a>
        </div>

        {/* Small line */}
        <div className="mt-8 anim-fade-up delay-7">
          <p className="text-[14px] text-[#64748B]">
            Saw us on best of Bend? That's us.{" "}
            <a
              href="#process"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#process")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="text-[#0064E0] hover:text-[#0052CC] underline underline-offset-4 decoration-[#0064E0]/30 hover:decoration-[#0064E0] transition-colors"
            >
              Here's the quick version.
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};
